import { Controller } from '@hotwired/stimulus'

export default class RisksStepController extends Controller {
  static targets = ['answer', 'form', 'modal']
  static values = { correctAnswers: Array }
  
  connect() {
    this.modal = new bootstrap.Modal(this.modalTarget);
    this.checkAnswers();
  }

  checkAnswers() {
    this.shouldShowModal = true;
    
    this.answerTargets.forEach((element) => {
      if(element.checked && this.correctAnswersValue.includes(element.value)) {
        this.shouldShowModal = false;
      }
    });
  }

  handleSubmit(event) {
    if(this.shouldShowModal) {
      event.preventDefault();
      this.modal.show();
    }
  } 

  handleModalButtonClick() {
    this.formTarget.submit();
  }
}
